<template lang="pug">
  v-form(ref="form")
    v-row(no-gutters)
      v-col(:cols="blast.enabled ? 12 : 7")
        v-card.rounded-lg.content-box.pa-6(outlined)
          v-row
            v-col(:cols="blast.enabled ? 7 : 12")
              v-row(no-gutters align="center")
                v-col.grow
                  div.d-flex.align-center
                    .text-md.font-semibold SMS delivery
                    y-chip.ml-2(v-if="blastData && blast.enabled && checkPaused(blastData)" label="Paused" color="red")
                v-col.shrink(v-if="blastData && blast.enabled && offer.status !== 'draft'")
                  y-button.mr-3(label="Deliverance details" outlined size="xxs" @click="showDeliveranceDetailsDialog = true")
                v-col.shrink
                  y-switch.mb-n3(v-model="blast.enabled")

              v-row.my-4(v-if="blast.enabled")
                v-divider.neutral300

              template(v-if="blast.enabled")
                //- Sender ID
                div.text-md.font-semibold.neutral700--text Sender ID
                v-text-field.text-sm.mt-2.round-xl(v-model="senderID" placeholder="Sender ID" outlined dense height="48" disabled :loading="isFetching" hide-details="auto")
                  template(v-slot:append)
                    v-btn.button-sm(outlined style="margin-top: -2px" @click.stop="handleRedirectSenderId") Edit
                //- Thank you message
                div.text-md.font-semibold.neutral700--text.mt-5 Thank you message
                v-textarea.text-sm.mt-2.round-xl(ref="textarea" v-model="blast.content" placeholder="Type your message here" outlined rows="6" hide-details="auto" :rules="rules.not_empty" :prefix="senderIDPrefix" @input="updateCursor" @change="updateCursor" @focus="updateCursor")
                div.text-sm.font-normal.neutral700--text.mt-1.text-right Character Count {{contentLength.length}} | SMS Count {{contentLength.numSMS}} | Cost RM {{contentLength.cost.toFixed(2)}} per recipient
                template(v-if="offer.redeem_method != 'show_message'")
                div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
                v-chip.mt-1.mr-1(v-if="offer.end_at" link small outlined color="neutral400" @click="insertValue('expiry_date')")
                  span.neutral700--text Expiry date
                v-chip.mt-1.mr-1(link small outlined color="neutral400" @click="insertValue('offer_code')")
                  span.neutral700--text Redemption code
                v-chip.mt-1(v-if="hasSmsHeader" link small outlined color="neutral400" @click="insertValue('brand_name')")
                  span.neutral700--text Brand name (Sender ID)
                //- Blast settings
                div.text-sm.font-semibold.neutral700--text.mt-6 Blast settings
                v-card.round-xl.mt-2.pa-3(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                  v-radio-group.mt-0(v-model="blast.send_to" hide-details)
                    v-radio(value="all" color="neutral700")
                      template(v-slot:label)
                        div.text-sm.font-medium.neutral700--text Send to everyone
                    div.ml-8.mb-3(v-if="blast.send_to === 'all'")
                      v-radio-group.mt-0(v-model="sendCue" hide-details)
                        v-radio(value="scheduled" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text On specific date and time
                        template(v-if="sendCue === 'scheduled'")
                          v-row.mb-2.ml-6(dense)
                            v-col(cols="4")
                              date-picker-field(v-model="date" required :min="getTodayDate()")
                            v-col(cols="4")
                              v-text-field.text-sm.round-xl(v-model="time" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                        v-radio(value="offer_ended" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text Right after the campaign ended
                    v-radio(value="redeemed_recipient" color="neutral700" style="align-items: unset;")
                      template(v-slot:label)
                        div.text-sm.font-medium.neutral700--text Send to customer that redeemed the offer
                    div.ml-8(v-if="blast.send_to === 'redeemed_recipient'")
                      v-radio-group.mt-0(v-model="sendCue" hide-details)
                        v-radio(value="offer_redeemed" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text Send after specific minute after redemption
                        template(v-if="sendCue === 'offer_redeemed'")
                          v-row.mb-3(no-gutters)
                            v-col(cols="6")
                              v-text-field.text-sm.round-xl.pl-8(v-model="minutes" placeholder="0" outlined dense height="48" :rules="rules.has_quantity" suffix="minute" type="number" hide-details="auto")
                        v-radio(value="scheduled" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text On specific date and time
                        template(v-if="sendCue === 'scheduled'")
                          v-row.mb-3.ml-6(dense)
                            v-col(cols="4")
                              date-picker-field(v-model="date" required :min="getTodayDate()")
                            v-col(cols="4")
                              v-text-field.text-sm.round-xl(v-model="time" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                        v-radio(value="offer_ended" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text Right after the campaign ended

            v-divider.neutral300.my-n3(v-if="blast.enabled" vertical)
            //- Preview
            v-col.pt-0(v-if="blast.enabled" cols="5")
              sms-preview(title="Thank you message preview" :sender="senderIDPrefix" :content="blast.content")

    .dialogs
      deliverance-details-dialog(v-if="showDeliveranceDetailsDialog" :open.sync="showDeliveranceDetailsDialog" :blast-data="blastData")

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {DateTime} from 'luxon'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import SmsPreview from '@/components/clinic/marketing/SmsPreview.vue'
import DeliveranceDetailsDialog from '@/components/clinic/marketing/dialogs/DeliveranceDetailsDialog.vue'

export default {
  components: {
    DatePickerField, SmsPreview, DeliveranceDetailsDialog
  },
  props: {
    blastData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isFetching: false,
      showDeliveranceDetailsDialog: false,
      cursorPosition: 0,
      minutes: 0,
      sendCue: 'offer_ended',
      time: '00:00',
      date: null,
      blast: {
        name: 'Thank you message',
        send_to: 'all',
        type: 'thank_you',
        method: 'sms',
        enabled: true,
        content: 'Thank you for redeeming your offer! We hope to serve you again soon.'
      },
      schedules: [{time: '00:00'}],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer',
      setting: 'marketing/getMarketingSettings'
    }),
    hasSmsHeader () {
      return this.setting && this.setting.sms_header
    },
    senderID() {
      let text = null
      if (this.hasSmsHeader) {
        text = `RM0 ${this.setting.sms_header}`
      }
      return text
    },
    senderIDPrefix () {
      return `${this.senderID}: `
    },
    contentLength() {
      let text = this.blast?.content || ''
      text = text + this.senderIDPrefix
      text = text.replace(/{{ offer_code }}/g, this.replaceCodeValue)
      text = text.replace(/{{ expiry_date }}/g, this.replaceExpiryDataValue)
      text = text.replace(/{{ brand_name }}/g, this.replaceBrandNameValue)
      const length = text ? text.length : 0;
      const charLength = 155
      const numSMS = Math.ceil(length / charLength);
      const cost = numSMS * 0.15
      return { length, numSMS, cost };
    },
    textarea() {
      return this.$refs.textarea.$el.querySelector('textarea')
    },
    replaceCodeValue () {
      if (this.offer.redeem_method === 'unique_code') return 'CODE'
      if (this.offer.redeem_method === 'general_code') return this.offer.coupon_code
      return ''
    },
    replaceExpiryDataValue () {
      if (this.offer.end_at) return this.$options.filters.displayDate(this.offer.end_at)
      return ''
    },
    replaceBrandNameValue () {
      if (this.hasSmsHeader) return this.setting.sms_header
      return ''
    }
  },
  watch: {},
  mounted() {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData() {
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        if (blast.schedules.length) {
          this.date = DateTime.fromISO(blast.schedules[0].scheduled_for).toFormat('yyyy-MM-dd')
          this.time = DateTime.fromISO(blast.schedules[0].scheduled_for).toFormat('HH:mm')
        }
        this.sendCue = blast.send_cue
        this.minutes = blast.auto_send_delay_time_value
        this.blast = blast
      }
    },
    updateCursor() {
      const postion = this.textarea.selectionStart
      if (!postion) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue (value) {
      let text = ''
      const code = `{{ ${value} }}`
      if (this.blast.content) {
        text = `${this.blast.content.substring(0, this.cursorPosition)}${code}${this.blast.content.substring(this.cursorPosition, this.blast.content.length)}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    validateData () {
      return this.$refs.form.validate()
    },
    saveData () {
      if (!this.validateData()) {
        return
      }
      const payload = this.getPayload()
      if (this.blast.id) {
        return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
      }
      return this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
    },
    getTodayDate() {
      return DateTime.local().toFormat('yyyy-MM-dd')
    },
    handleRedirectSenderId() {
      this.$router.push('/admin/clinic/settings/marketing')
    },
    getPayload () {
      if (!this.blastData && !this.blast.enabled) {
        return {
          name: this.blast.name,
          method: this.blast.method,
          type: this.blast.type,
          content: this.blast.content,
          enabled: false,
        }
      }
      if (!this.blast.enabled) {
        return {
          enabled: false
        }
      }
      let payload = {
        name: this.blast.name,
        method: this.blast.method,
        type: this.blast.type,
        content: this.blast.content,
        send_to: this.blast.send_to,
        enabled: this.blast.enabled
      }
      payload.send_cue = this.sendCue
      if (this.sendCue === 'scheduled') {
        payload.schedules = [`${this.date} ${this.time}`]
      }
      if (this.sendCue === 'offer_redeemed') {
        payload.auto_send_delay_time_value = this.minutes
        payload.auto_send_delay_time_unit = 'minutes'
      }
      return payload
    },
    checkPaused (data) {
      let paused = false
      if (data.schedules.find(f => f.status === 'paused')) {
        paused = true
      }
      return paused
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover {
    cursor: pointer;
    background: var(--v-neutral200) !important;
  }

  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }

  .error--text {
    color: var(--v-danger500) !important;

    fieldset {
      border-color: var(--v-danger500);
    }
  }

  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>